import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefobjekt-hinzufuegen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefobjektHinzufuegenEffects {

    PruefobjektHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFOBJEKT_HINZUFUEGEN),
        mergeMap((x: ac.PostPruefobjektHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefobjektHinzufuegen(x.pruefobjektModelRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefobjektHinzufuegenErfolgreichAction(result, x.pruefobjektModelRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefobjektHinzufuegenFehlerAction(error, x.pruefobjektModelRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
